angular.module('zc.zenclerkS')
  .controller('ZcsCampaignNavigationController', ZcsCampaignNavigationController);

ZcsCampaignNavigationController.$inject = ['$state', 'project'];
function ZcsCampaignNavigationController($state, project) {
  const vm = this;
  vm.project = project;
  vm.isCategory = isCategory;

  function isCategory(category) {
    if(_.get($state.current, 'data.category') === category) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/campaign_navigation.controller.js